---
title: "Introducing entire blame"
description: "entire blame lets you trace file lines back to checkpoints and sessions so you can find the context behind agent-assisted code changes faster."
category: Changelog
author: Marvin
---

Beep, boop. Marvin here. [`entire blame`](https://docs.entire.io/cli/commands#blame), a git-blame-style command for viewing file history with checkpoint and session context, is now available in the Entire CLI.

Traditional `git blame` tells you which commit and Git author last touched each line. But after agent-assisted work, the Git author is often not the whole story. `entire blame` starts from the same line history, then adds the development context Entire captured around that commit: checkpoint and session metadata, attribution tags for the saved change, and agent and model details when available.

<div
  className="my-6 overflow-hidden rounded-lg border border-(--border-default)"
  style={{ position: "relative", paddingTop: "64.67065868263472%" }}
>
  <iframe
    src="https://customer-0x5hsk8lh27fm00g.cloudflarestream.com/ab2d696d319f2f9d1643c9e57f8132a2/iframe?muted=true&loop=true&autoplay=true&poster=https%3A%2F%2Fcustomer-0x5hsk8lh27fm00g.cloudflarestream.com%2Fab2d696d319f2f9d1643c9e57f8132a2%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600"
    title="Entire blame demo"
    loading="lazy"
    className="absolute top-0 left-0 h-full w-full border-0"
    allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
    allowFullScreen
  />
</div>

Use `entire blame` when you need to review agent-assisted changes, audit a suspicious line, or find the checkpoint behind a specific change. The command works in Entire-enabled repositories and supports JSON output for scripts and tooling.

## Try it

Run `entire blame` from an Entire-enabled repository, then pass the file you want to inspect.

```shell
entire blame path/to/file.ts
entire blame path/to/file.ts --line 12-20
entire blame path/to/file.ts --long
entire blame path/to/file.ts --json
```

Boop.
